import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-three-state-checkbox',
  templateUrl: './three-state-checkbox.component.html',
  styleUrls: ['./three-state-checkbox.component.scss']
})
export class ThreeStateCheckboxComponent implements OnInit {

  @Input()
  public idAndName: string;

  @Input()
  public status: boolean | null;

  @Input()
  public label: string = '';

  @Output()
  public statusChanged = new EventEmitter<boolean | null>();

  constructor() {
    this.status = null;
    this.idAndName = '1';
  }

  ngOnInit(): void {
  }

  changeStatus() {
    switch (this.status) {
      case true: {
        this.status = false;
        break;
      }
      case false: {
        this.status = null;
        break;
      }
      case null: {
        this.status = true;
        break;
      }
    }
    this.statusChanged.emit(this.status);
  }

}
